import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from './../../../core/service/base/data.service';
import { MessageService } from './../../../core/service/message.service';
import { ProgressBarService } from './../../../core/service/progress-bar.service';
import { Observable, catchError, map } from 'rxjs';
import { Company } from '../../../rent/model/company';
import { Property } from '../../../rent/model/property';
import { RentalObjectKey } from '../../model/rental-object-key';
import { PagedResult } from '../../../core/model/paged-result';

@Injectable()
export class RentalObjectKeyService extends DataService<RentalObjectKey> {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) private _config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(_client, _config, messageService, RentalObjectKey, progressBar, 'rental-object-key');
  }

  override getPagedList(
    filter: any,
    page: number,
    pageSize: number,
    order: string,
    descending: boolean
  ): Observable<PagedResult<RentalObjectKey>> {
    return super.getPagedList(filter, page, pageSize, order, descending).pipe(
      map(result => {
        if (!order) {
          result.items = [...result.items].sort((a, b) => this.compareDefaultListOrder(a, b));
        }

        return result;
      })
    );
  }

  getFilterDefinition(): Observable<{
    keyTypeId: string;
    rentalId: string;
    rentalObjectId: string;
    companyId: string;
    propertyId: string;
    buildingId: string;
    entranceId: string;
    captionContains: string;
    keyContains: string;
    markingContains: string;
    supplierContains: string;
    systemNumberContains: string;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client
      .get<any>(`${this.endpoint}/filter`)
      .pipe(
        map(res => res.filter),
        map(res => {
          return {
            keyTypeId: res.keyTypeId ? res.keyTypeId : '',
            rentalId: res.rentalId ? res.rentalId : '',
            rentalObjectId: res.rentalObjectId ? res.rentalObjectId : '',
            companyId: res.companyId ? res.companyId : '',
            propertyId: res.propertyId ? res.propertyId : '',
            buildingId: res.buildingId ? res.buildingId : '',
            entranceId: res.entranceId ? res.entranceId : '',
            captionContains: res.captionContains ? res.captionContains : '',
            keyContains: res.keyContains ? res.keyContains : '',
            markingContains: res.markingContains ? res.markingContains : '',
            supplierContains: res.supplierContains ? res.supplierContains : '',
            systemNumberContains: res.systemNumberContains ? res.systemNumberContains : '',
            selectedFields: Array.isArray(res.selectedFields)
              ? res.selectedFields
              : ['companyId', 'propertyId', 'keyTypeId', 'captionContains'],
            defaultFields: ['captionContains'],
          };
        })
      )
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }

  private compareDefaultListOrder(a: RentalObjectKey, b: RentalObjectKey): number {
    return (
      this.compareText(a.rentalId, b.rentalId) ||
      this.compareText(a.keyTypeName, b.keyTypeName) ||
      this.compareText(a.systemNumber, b.systemNumber) ||
      this.compareText(a.marking, b.marking) ||
      this.compareText(a.caption, b.caption)
    );
  }

  private compareText(a: string, b: string): number {
    return (a || '').localeCompare(b || '');
  }
}
